import React, { useState, useEffect } from "react"
// import 'materialize-css/dist/css/materialize.min.css';
import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles'

import { withAuthentication } from './contexts/Session'
import Routes from './utils/routes/routes.js';
import MyContext from './contexts/_ModalData/modal'
import './Global.css';

function App(props){

    const[authUser, setAuthUser] = useState(null)
    const[dataPF, setDataPF] = useState({})
    const[dataPJ, setDataPJ] = useState({})
    const[docsImage, setDocsImage] = useState({})
    const[denunciations, setDenunciations] = useState({})

    const theme = createMuiTheme({
        palette: {primary: {main: '#5C597D'}, secondary:{main:'#FFFFFF'}}
    });

    useEffect(() => {
        const listener = props.firebase.auth.onAuthStateChanged(authUser => {
            authUser
                ? setAuthUser(authUser)
                : setAuthUser(null);
        });
    
        return function cleanUp() {
            listener();
        }
    
    })
    return (
        <MyContext.Provider value={{dataPF, setDataPF, dataPJ, setDataPJ, denunciations, setDenunciations, docsImage, setDocsImage}}>
            <ThemeProvider theme={theme}>
                <Routes authUser={authUser}/>
            </ThemeProvider>
        </MyContext.Provider>
    );
}

export default withAuthentication(App)